var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardTodos = function SvgDashboardTodos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#dashboard-todos_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 20.839 29.548 10.387 9.678 30.323 19.354 40H20c10.774 0 19.548-8.516 20-19.161",
    clipRule: "evenodd",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFCF2",
    fillRule: "evenodd",
    d: "M9.677 30.323s4.323-.968 5.549-1.936l-3.613-3.613c-.968 1.226-1.936 5.549-1.936 5.549m14.84-18.452-12 12 3.677 3.677 12-12z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#344E5F",
    fillRule: "evenodd",
    d: "m11.613 24.774 3.677 3.678.904-.904-3.678-3.677zm13.806-13.806-.903.903 3.678 3.677.903-.903z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDC03D",
    fillRule: "evenodd",
    d: "M27.742 9.677c-.71 0-1.355.258-1.807.775l-.516.516 3.678 3.677.516-.516c.451-.452.774-1.097.774-1.806-.064-1.484-1.226-2.646-2.645-2.646",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dashboard-todos_svg__a",
    x1: 0,
    x2: 39.142,
    y1: 0,
    y2: -0.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E72ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6597FF"
  })))));
};
export { SvgDashboardTodos as ReactComponent };
export default __webpack_public_path__ + "fonts/dashboard-todos-1f018b990b70aae18036a773c5002b9b.svg";